var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDropdown = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "23px",
    viewBox: "0 0 23 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "804FB2BC-9D71-4BED-91D3-BFDCB5DB7876") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CNC---Cuisine",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Preparer-+-commande",
    transform: "translate(-1378.000000, -988.000000)",
    fill: "#5F7081",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(1056.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy",
    transform: "translate(30.000000, 969.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Atom/icons/chevron-bas-plein",
    transform: "translate(292.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,11.5 C7.77806814e-16,17.8512746 5.14872538,23 11.5,23 C17.8512746,23 23,17.8512746 23,11.5 C23,5.14872538 17.8512746,3.88903407e-16 11.5,0 C5.14872538,-3.88903407e-16 7.77806814e-16,5.14872538 0,11.5 Z M12.8448505,7.6067883 L16.6441377,11.7321262 C16.8950271,12.0060326 17.0236311,12.3849904 16.9964112,12.7701709 C16.9691912,13.1553514 16.7888459,13.5085682 16.5024074,13.7377057 C15.999266,14.1211508 15.3140733,14.0506449 14.8862245,13.5714014 L11.5029843,9.89036885 L8.07402472,13.613598 C7.8217668,13.8860184 7.47276041,14.0256591 7.11802305,13.9961032 C6.76328569,13.9665472 6.43798582,13.7707248 6.22695849,13.4597046 C5.87381933,12.9133841 5.93875273,12.1693889 6.38011868,11.7048225 L10.1496883,7.6067883 C10.5068868,7.2183024 10.991702,7 11.4972694,7 C12.0028368,7 12.487652,7.2183024 12.8448505,7.6067883 Z",
    transform: "translate(11.500000, 11.500000) scale(1, -1) translate(-11.500000, -11.500000) "
  }))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDropdown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dropdown.847a6a257e8dad99cdc7c1588b6959ea.svg";